<template>
  <div class="application">
    <div class="header">
      <div class="title">应用场景</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="list">
        <div class="item" v-for="item in applicationList" :key="item.id">
          <img :src="item.logo" alt="" />
          <div>{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import application1 from "../../../../assets/product/application1.png";
import application2 from "../../../../assets/product/application2.png";
import application3 from "../../../../assets/product/application3.png";
import application4 from "../../../../assets/product/application4.png";
import application5 from "../../../../assets/product/application5.png";
import application6 from "../../../../assets/product/application6.png";
import application7 from "../../../../assets/product/application7.png";
import application8 from "../../../../assets/product/application8.png";

export default {
  setup() {
    return reactive({
      applicationList: [
        {
          id: 1,
          title: "住宅小区",
          logo: application1,
        },
        {
          id: 2,
          title: "办公楼",
          logo: application2,
        },
        {
          id: 3,
          title: "商场",
          logo: application3,
        },
        {
          id: 4,
          title: "酒店",
          logo: application4,
        },
        {
          id: 5,
          title: "产业园",
          logo: application5,
        },
        {
          id: 6,
          title: "旅游景区",
          logo: application6,
        },
        {
          id: 7,
          title: "工厂",
          logo: application7,
        },
        {
          id: 8,
          title: "学校",
          logo: application8,
        },
      ],
    });
  },
};
</script>

<style scoped>
.application {
  width: 1180px;
  margin: 80px auto;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body .list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 60px;
  justify-content: space-between;
}
.body .list .item {
  text-align: center;
  margin-bottom: 40px;
  overflow: hidden;
}
.body .list .item:hover img {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.body .list .item img {
  width: 280px;
}
.body .list .item div {
  margin-top: 20px;
}
</style>
